import { QRFC } from "./QRFC";

export class QGetUserListRFC extends QRFC {
  constructor() {
    super();
    this.fRefresh = null;
    this.fSelectID = null;
  }

  InitGetUserListRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qgetuserlist";
  }

  SetParams(orgName, user, self, mfaOnly) {
    this.AddEncodedParameter("org", orgName);
    this.AddEncodedParameter("user", user);
    this.AddEncodedParameter("mfaOnly", mfaOnly ? true : false);
    if (self) this.AddParameter("self", self);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = response;
    r = JSON.parse(r);
    var success = r["success"];
    var userList = null;
    var groupInfo = null;

    if (success) {
      userList = r["userlist"];
      if (r["summaryOnly"]) callBackObj.InactiveMFAWarning(r["mfaSummary"]);
      if (r["groupinfo"]) groupInfo = r["groupinfo"];
    }

    callBackObj.GetUserListResult(success, userList, groupInfo, r["mfaSummary"]);
  }
}
